import { useOptionalDetailVisible } from 'context/dash/DetailVisible';
import { canInEvent, grantedLabels, isCollaboration } from 'helpers/eventCollaboration';
import usePanelPermissions from 'hooks/usePanelPermissions';

/**
 * O que a pessoa pode no evento aberto no painel. No evento próprio é tudo;
 * no evento em que só colabora (`collaboration` vem da lista do painel) é o
 * que o convite liberou.
 */
export default function useEventAccess() {
    const { detailVisible } = useOptionalDetailVisible();
    const { can: canInPanel } = usePanelPermissions();
    const collaboration = isCollaboration(detailVisible);

    return {
        isCollaboration: collaboration,
        owner: detailVisible?.collaboration?.owner || null,
        grantedLabels: grantedLabels(detailVisible),
        can: (...permissions) => canInEvent(detailVisible, ...permissions),
        // Quem pode mexer no que é do evento (cupons, despesas): no evento de
        // outro produtor decide o convite; no próprio, ou em nome do produtor,
        // a permissão do painel.
        canManage: (panelPermission, invitePermission) => (
            collaboration ? canInEvent(detailVisible, invitePermission) : canInPanel(panelPermission)
        ),
    };
}
